import Toastify from "toastify-js";

const successColor = "#34D399";
const errorColor = "#EF4444";

function displayToast(message, kind, callback) {
  Toastify({
    text: message,
    gravity: "bottom",
    duration: 3000,
    className: "!max-w-full !text-sm !rounded-md !left-4 !right-4 !mb-[65px]",
    style: { background: kind === "success" ? successColor : errorColor },
    callback: callback,
    escapeMarkup: false,
  }).showToast();
}

export { displayToast };
